import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./newProject.css";
import { BASE_URL } from "../apiConfig";
import { message } from "antd";
import { ChevronLeft, ChevronRight, Trash2 } from "lucide-react";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import dayjs from "dayjs";

const NewProject = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const navigate = useNavigate();
  const { clientID } = useParams();
  const { roleId } = useParams();

  const [projectId, setProjectId] = useState("");
  const [clientName, setClientName] = useState("");
  const [projectName, setProjectName] = useState("");
  const [isProjectCreated, setIsProjectCreated] = useState(false);
  const [toggleOpen, setToggleOpen] = useState(false);
  const [departments, setDepartments] = useState([""]);
  const [designations, setDesignations] = useState([""]);
  dayjs.extend(duration);
  dayjs.extend(isSameOrBefore);

  // Restrict all date pickers to ±10 years from today
  const datePickerMinDate = dayjs().subtract(10, "year").startOf("day");
  const datePickerMaxDate = dayjs().add(10, "year").endOf("day");
  const disabledDateOutsideRange = (current) => {
    if (!current) return false;
    return (
      current.isBefore(datePickerMinDate, "day") ||
      current.isAfter(datePickerMaxDate, "day")
    );
  };

  const [errors, setErrors] = useState({
    projectName: "",
    spocName: "",
    projectStartDate: "",
    studyBeginDate: "",
    studyEndDate: "",
    earliestDateForDOJ: "",
    endDateForDOJ: "",
    dateComparison: "",
    departments: "",
    designations: "",
  });

  const [projectDetails, setProjectDetails] = useState({
    spocName: "",
    projectStartDate: dayjs(),
    studyBeginDate: null,
    studyEndDate: null,
    earliestDateForDOJ: null,
    endDateForDOJ: null,
  });

  const toValidDayjs = (value) => {
    return value && dayjs(value).isValid() ? dayjs(value) : null;
  };

  useEffect(() => {
    if (location.state && location.state.clientName) {
      setClientName(location.state.clientName);
    }
    if (location.state && location.state.projectName) {
      setProjectName("Copy " + location.state.projectName);
    }
    if (location.state && location.state.departments) {
      setDepartments(location.state.departments);
    }
    if (location.state && location.state.designations) {
      setDesignations(location.state.designations);
    }
    if (location.state?.projectDetailsSend) {
      const received = location.state.projectDetailsSend;
      console.log("Received project details:", received);

      setProjectDetails({
        spocName: received.spocName || "",
        projectStartDate: toValidDayjs(received.projectStartDate),
        studyBeginDate: toValidDayjs(received.studyBeginDate),
        studyEndDate: toValidDayjs(received.studyEndDate),
        earliestDateForDOJ: toValidDayjs(received.earliestDateForDOJ),
        endDateForDOJ: toValidDayjs(received.endDateForDOJ),
      });
    }
  }, [location.state]);

  useEffect(() => {
    if (isProjectCreated) {
      validateDepartments();
    }
  }, [departments, isProjectCreated]);

  useEffect(() => {
    if (isProjectCreated) {
      validateDesignations();
    }
  }, [designations, isProjectCreated]);

  useEffect(() => {
    if (projectDetails.studyBeginDate && projectDetails.studyEndDate) {
      const beginDate = dayjs(projectDetails.studyBeginDate);
      const endDate = dayjs(projectDetails.studyEndDate);

      // Calculate month difference
      const monthsDifference = endDate.diff(beginDate, "month");
      const monthsToSubtract = 2 * monthsDifference;

      // Subtract months from end date
      const calculatedDate = endDate.subtract(monthsToSubtract + 1, "month");

      // Keep only the day from begin date, preserve year and month from calculation
      const earliestDate = calculatedDate.date(beginDate.date());

      const endDateForDOJ = endDate;

      setProjectDetails((prev) => ({
        ...prev,
        earliestDateForDOJ: earliestDate,
        endDateForDOJ: endDateForDOJ,
      }));
    }
  }, [projectDetails.studyBeginDate, projectDetails.studyEndDate]);

  // useEffect(() => {
  //   if (projectDetails.studyBeginDate && projectDetails.studyEndDate) {
  //     const beginDate = dayjs(projectDetails.studyBeginDate);
  //     const endDate = dayjs(projectDetails.studyEndDate);

  //     const studyStartYear = beginDate.year();
  //     const studyEndYear = endDate.year();
  //     const yearsDifference = studyEndYear - studyStartYear;

  //     const yearsToSubtract = 2 * yearsDifference;
  //     const earliestDOJYear = studyEndYear - yearsToSubtract;

  //     const beginDateStr = beginDate.format("MM-DD");
  //     const earliestDateStr = `${earliestDOJYear}-${beginDateStr}`;
  //     const earliestDate = dayjs(earliestDateStr, "YYYY-MM-DD");

  //     const endDateForDOJ = endDate;

  //     setProjectDetails((prev) => ({
  //       ...prev,
  //       earliestDateForDOJ: earliestDate,
  //       endDateForDOJ: endDateForDOJ,
  //     }));
  //   }
  // }, [projectDetails.studyBeginDate, projectDetails.studyEndDate]);

  //   useEffect(() => {
  //   if (projectDetails.studyBeginDate && projectDetails.studyEndDate) {
  //     const beginDate = dayjs(projectDetails.studyBeginDate);
  //     const endDate = dayjs(projectDetails.studyEndDate);

  //     const diffInYears = endDate.diff(beginDate, 'year');
  //     const diffInMonths = endDate.diff(beginDate, 'month');
  //     const diffInDays = endDate.diff(beginDate, 'day');

  //     let earliestDate;

  //     if (diffInYears >= 1) {
  //       earliestDate = endDate.subtract(2 * diffInYears, 'year');
  //     } else if (diffInMonths >= 1) {
  //       earliestDate = endDate.subtract(2 * diffInMonths, 'month');
  //       console.log((2 * diffInMonths));
  //     } else {
  //       earliestDate = endDate.subtract(2 * diffInDays, 'day');
  //     }

  //     setProjectDetails((prev) => ({
  //       ...prev,
  //       earliestDateForDOJ: earliestDate,
  //       endDateForDOJ: endDate,
  //     }));
  //   }
  // }, [projectDetails.studyBeginDate, projectDetails.studyEndDate]);

  const validateProjectName = () => {
    const specialCharRegex = /^[a-zA-Z0-9 ]+$/;

    if (!projectName.trim()) {
      setErrors((prev) => ({
        ...prev,
        projectName: "Project name is required",
      }));
      return false;
    } else if (projectName.length < 4) {
      setErrors((prev) => ({
        ...prev,
        projectName: "Minimum Character Limit not met, please contact Admin",
      }));
      return false;
    } else if (projectName.length > 40) {
      setErrors((prev) => ({
        ...prev,
        projectName:
          "Maximum Character Limit Exceeded, please recheck or contact Admin",
      }));
      return false;
    } else if (!specialCharRegex.test(projectName)) {
      setErrors((prev) => ({
        ...prev,
        projectName: "Special characters are not allowed",
      }));
      return false;
    }

    setErrors((prev) => ({ ...prev, projectName: "" }));
    return true;
  };

  const validateDepartments = () => {
    // Check if there's at least one non-empty department
    const validDepartments = departments.filter((dept) => dept.trim() !== "");
    if (validDepartments.length === 0) {
      setErrors((prev) => ({
        ...prev,
        departments: "At least one department is required",
      }));
      return false;
    }
    const normalizedDepartments = validDepartments.map((dept) =>
      dept.trim().toLowerCase()
    );
    if (new Set(normalizedDepartments).size !== normalizedDepartments.length) {
      setErrors((prev) => ({
        ...prev,
        departments: "Duplicate department values are not allowed",
      }));
      return false;
    }
    setErrors((prev) => ({ ...prev, departments: "" }));
    return true;
  };

  const validateDesignations = () => {
    // Check if there's at least one non-empty designation
    const validDesignations = designations.filter(
      (desig) => desig.trim() !== ""
    );
    if (validDesignations.length === 0) {
      setErrors((prev) => ({
        ...prev,
        designations: "At least one designation is required",
      }));
      return false;
    }
    const normalizedDesignations = validDesignations.map((designation) =>
      designation.trim().toLowerCase()
    );
    if (new Set(normalizedDesignations).size !== normalizedDesignations.length) {
      setErrors((prev) => ({
        ...prev,
        designations: "Duplicate designation values are not allowed",
      }));
      return false;
    }
    setErrors((prev) => ({ ...prev, designations: "" }));
    return true;
  };

  const validateProjectDetails = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Validate SPOC Name
    if (!projectDetails.spocName.trim()) {
      newErrors.spocName = "SPOC Name is required";
      isValid = false;
    } else {
      newErrors.spocName = "";
    }

    // Validate Project Start Date
    if (!projectDetails.projectStartDate) {
      newErrors.projectStartDate = "Project Start Date is required";
      isValid = false;
    } else {
      newErrors.projectStartDate = "";
    }

    // Validate Study Begin Date
    if (!projectDetails.studyBeginDate) {
      newErrors.studyBeginDate = "Study Begin Date is required";
      isValid = false;
    } else {
      newErrors.studyBeginDate = "";
    }

    // Validate Study End Date
    if (!projectDetails.studyEndDate) {
      newErrors.studyEndDate = "Study End Date is required";
      isValid = false;
    } else {
      newErrors.studyEndDate = "";
    }

    // Compare dates if both exist
    if (projectDetails.studyBeginDate && projectDetails.studyEndDate) {
      if (projectDetails.studyEndDate.isBefore(projectDetails.studyBeginDate)) {
        newErrors.dateComparison =
          "Study Period end date must be a date after the study period beginning date";
        isValid = false;
      } else {
        newErrors.dateComparison = "";
      }
    }

    // Explicitly validate departments and designations
    const deptValid = validateDepartments();
    const desigValid = validateDesignations();

    if (!deptValid || !desigValid) {
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleCreateProject = async (e) => {
    e.preventDefault();

    if (!validateProjectName()) {
      return;
    }

    try {
      const token = localStorage.getItem("accessToken");
      const requestBody = {
        client_id: clientID,
        jobrole_id: roleId,
        name: projectName,
      };

      const response = await fetch(`${BASE_URL}/project/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok) {
        setProjectId(data.id);
        setIsProjectCreated(true);
        messageApi.success("Project created successfully!");
      } else {
        messageApi.error(data.detail || "Failed to create project");
      }
    } catch (error) {
      console.error("Error creating project:", error);
      messageApi.error("An error occurred while creating the project");
    }
  };

  const handleUpdateProject = async (e) => {
    e.preventDefault();

    if (!validateProjectName()) {
      return;
    }

    try {
      const token = localStorage.getItem("accessToken");
      const requestBody = {
        name: projectName,
        project_id: projectId,
        jobrole_id: roleId,
      };

      const response = await fetch(`${BASE_URL}/project/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok) {
        setProjectId(data.id);
        messageApi.success("Project updated successfully!");
        setIsProjectCreated(true);
      } else {
        messageApi.error(data.detail || "Project already exists!");
      }
    } catch (error) {
      console.error("Error updating project:", error);
      messageApi.error("An error occurred while updating the project");
    }
  };

  const handlesubmit = async (e) => {
    e.preventDefault();

    // Force validation before submission
    const isValid = validateProjectDetails();

    if (!isValid) {
      messageApi.error("Please fill in all required fields correctly");

      // Explicitly show the errors for departments and designations
      validateDepartments();
      validateDesignations();

      return;
    }

    try {
      const token = localStorage.getItem("accessToken");
      const filteredDepartments = departments.filter(
        (dept) => dept.trim() !== ""
      );
      const filteredDesignations = designations.filter(
        (desig) => desig.trim() !== ""
      );

      // Format dates to YYYY-MM-DD before sending to API
      const requestBody = {
        project_id: projectId,
        project_details: {
          project_start_date: projectDetails.projectStartDate
            ? projectDetails.projectStartDate.format("YYYY-MM-DD")
            : null,
          client_spoc_name: projectDetails.spocName,
          study_period_begining_date: projectDetails.studyBeginDate
            ? projectDetails.studyBeginDate.format("YYYY-MM-DD")
            : null,
          study_period_end_date: projectDetails.studyEndDate
            ? projectDetails.studyEndDate.format("YYYY-MM-DD")
            : null,
          earliest_date_for_date_of_joining_relevent_for_the_study:
            projectDetails.earliestDateForDOJ
              ? projectDetails.earliestDateForDOJ.format("YYYY-MM-DD")
              : null,
          end_date_for_date_of_joining_relevent_for_the_study:
            projectDetails.endDateForDOJ
              ? projectDetails.endDateForDOJ.format("YYYY-MM-DD")
              : null,
          designations: filteredDesignations,
          departments: filteredDepartments,
        },
      };

      const response = await fetch(
        `${BASE_URL}/project/update_project_details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (response.ok) {
        navigate(`/architect/${clientID}/${roleId}/${projectId}/kpi`, {
          state: { clientName },
        });
      } else {
        const data = await response.json();
        messageApi.error(data.detail || "Failed to update project details");
      }
    } catch (error) {
      console.error("Error updating project details:", error);
      messageApi.error("An error occurred while submitting project details");
    }
  };

  const handleAddDepartment = () => {
    setDepartments([...departments, ""]);
  };

  const handleAddDesignation = () => {
    setDesignations([...designations, ""]);
  };

  const handleDeleteDepartment = (index) => {
    if (departments.length === 1) {
      setDepartments([""]);
      return;
    }
    setDepartments(departments.filter((_, itemIndex) => itemIndex !== index));
    setErrors((prev) => ({ ...prev, departments: "" }));
  };

  const handleDeleteDesignation = (index) => {
    if (designations.length === 1) {
      setDesignations([""]);
      return;
    }
    setDesignations(designations.filter((_, itemIndex) => itemIndex !== index));
    setErrors((prev) => ({ ...prev, designations: "" }));
  };

  const sanitizeNameInput = (value) =>
    value.replace(/[^a-zA-Z0-9\s]/g, "");

  const updateDepartment = (index, value) => {
    const sanitizedValue = sanitizeNameInput(value);
    const newDepartments = [...departments];
    newDepartments[index] = sanitizedValue;
    setDepartments(newDepartments);
    const nonEmptyDepartments = newDepartments
      .map((dept) => dept.trim().toLowerCase())
      .filter(Boolean);
    if (new Set(nonEmptyDepartments).size !== nonEmptyDepartments.length) {
      setErrors((prev) => ({
        ...prev,
        departments: "Duplicate department values are not allowed",
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, departments: "" }));
  };

  const updateDesignation = (index, value) => {
    const sanitizedValue = sanitizeNameInput(value);
    const newDesignations = [...designations];
    newDesignations[index] = sanitizedValue;
    setDesignations(newDesignations);
    const nonEmptyDesignations = newDesignations
      .map((designation) => designation.trim().toLowerCase())
      .filter(Boolean);
    if (new Set(nonEmptyDesignations).size !== nonEmptyDesignations.length) {
      setErrors((prev) => ({
        ...prev,
        designations: "Duplicate designation values are not allowed",
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, designations: "" }));
  };

  const handleProjectDetailChange = (field, value) => {
    setProjectDetails({
      ...projectDetails,
      [field]: value,
    });

    // Clear related error when field is updated
    setErrors((prev) => ({ ...prev, [field]: "" }));

    // Clear date comparison error if dates are changed
    if (field === "studyBeginDate" || field === "studyEndDate") {
      setErrors((prev) => ({ ...prev, dateComparison: "" }));
    }
  };

  const ErrorMessage = ({ message }) =>
    message ? (
      <div
        className="error-message"
        style={{ color: "#C12328", fontSize: "12px", marginTop: "4px" }}
      >
        {message}
      </div>
    ) : null;

  // Format date for display (if needed)
  const formatDate = (date) => {
    if (!date) return "";
    return dayjs(date).format("YYYY-MM-DD");
  };

  const handletoggleclick = () => {
    setToggleOpen(!toggleOpen);
  };

  return (
    <>
      {contextHolder}

      <div className="newProject-sidebar"></div>
      <div className="newproject-container">
        {/* Component 1: Create Project */}
        <div className="newproject-section">
          <button className="newproject-header" onClick={() => navigate(-1)}>
            <span className="newproject-back-arrow">
              <ChevronLeft />
            </span>
            <span className="newproject-title">Project Initialization</span>
          </button>

          <div className="newproject-form-row">
            <div className="newproject-form-group">
              <label className="newproject-label">Client's Name</label>
              <input
                type="text"
                className="newproject-input"
                placeholder="Enter Client Name"
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
                disabled
              />
            </div>
            <div className="newproject-form-group">
              <label className="newproject-label">
                Project's Name<span className="newproject-required">*</span>
              </label>
              <input
                type="text"
                className="newproject-input"
                placeholder="Enter Project Name"
                value={projectName}
                onChange={(e) => {
                  setProjectName(e.target.value);
                  if (errors.projectName) validateProjectName();
                }}
                onBlur={validateProjectName}
              />
              <ErrorMessage message={errors.projectName} />
            </div>
          </div>

          <button
            className={`newproject-create-btn ${
              clientName && projectName
                ? "newproject-create-btn-active"
                : "newproject-create-btn-disabled"
            }`}
            disabled={!clientName || !projectName}
            onClick={
              isProjectCreated ? handleUpdateProject : handleCreateProject
            }
          >
            {isProjectCreated ? "Update Project" : "Create Project"}
          </button>
        </div>

        {/* <div
          className={`newproject-section ${
            isProjectCreated ? "" : "newproject-section-disabled"
          }`}
        >
          <div className="newproject-header-row">
            <h3 className="newproject-section-title">
              Copy Details from Existing Project
            </h3>
            <label className="switch-container">
              <input
                type="checkbox"
                checked={toggleOpen}
                onChange={handletoggleclick}
                disabled={!isProjectCreated}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div> */}

        {/* Component 2: Project Details (with new fields) */}
        <div
          className={`newproject-section ${
            isProjectCreated ? "" : "newproject-section-disabled"
          }`}
        >
          <div className="newproject-form-grid">
            <div className="newproject-form-group">
              <label className="newproject-label">
                Project SPOC Name<span className="newproject-required">*</span>
              </label>
              <input
                type="text"
                className="newproject-input"
                placeholder="Enter SPOC Name"
                value={projectDetails.spocName}
                onChange={(e) =>
                  handleProjectDetailChange("spocName", e.target.value)
                }
                disabled={!isProjectCreated}
              />
              <ErrorMessage message={errors.spocName} />
            </div>
            <div className="newproject-form-group">
              <label className="newproject-label">
                Project Start Date<span className="newproject-required">*</span>
              </label>
              <DatePicker
                placeholder="Select Date"
                className="newproject-datepicker"
                format="DD-MM-YYYY"
                value={projectDetails.projectStartDate}
                onChange={(date) =>
                  handleProjectDetailChange("projectStartDate", date)
                }
                disabled={!isProjectCreated}
                minDate={datePickerMinDate}
                maxDate={datePickerMaxDate}
                disabledDate={disabledDateOutsideRange}
              />
              <ErrorMessage message={errors.projectStartDate} />
            </div>
            <div className="newproject-form-group">
              <label className="newproject-label">
                Study Period Beginning Date
                <span className="newproject-required">*</span>
              </label>
              <DatePicker
                placeholder="Select Date"
                className="newproject-datepicker"
                format="DD-MM-YYYY"
                value={projectDetails.studyBeginDate}
                onChange={(date) =>
                  handleProjectDetailChange("studyBeginDate", date)
                }
                disabled={!isProjectCreated}
                minDate={datePickerMinDate}
                maxDate={datePickerMaxDate}
                disabledDate={disabledDateOutsideRange}
              />
              <ErrorMessage message={errors.studyBeginDate} />
            </div>
            <div className="newproject-form-group">
              <label className="newproject-label">
                Study Period End Date
                <span className="newproject-required">*</span>
              </label>
              <DatePicker
                placeholder="Select Date"
                className="newproject-datepicker"
                format="DD-MM-YYYY"
                value={projectDetails.studyEndDate}
                onChange={(date) =>
                  handleProjectDetailChange("studyEndDate", date)
                }
                disabled={!isProjectCreated}
                minDate={datePickerMinDate}
                maxDate={datePickerMaxDate}
                disabledDate={disabledDateOutsideRange}
              />
              <ErrorMessage message={errors.studyEndDate} />
              <ErrorMessage message={errors.dateComparison} />
            </div>

            <div className="newproject-form-group">
              <label className="newproject-label">
                Earliest Date for DOJ Relevant for Study
                <span className="newproject-required">*</span>
              </label>
              <DatePicker
                className="newproject-datepicker"
                format="DD-MM-YYYY"
                value={projectDetails.earliestDateForDOJ}
                onChange={(date) =>
                  handleProjectDetailChange("earliestDateForDOJ", date)
                }
                minDate={datePickerMinDate}
                maxDate={datePickerMaxDate}
                disabledDate={disabledDateOutsideRange}
                // disabled={true}
              />
              {/* <small className="helper-text" style={{ fontSize: '11px', color: '#666' }}>
                                Auto-calculated based on study period
                            </small> */}
            </div>

            <div className="newproject-form-group">
              <label className="newproject-label">
                End Date for DOJ Relevant for Study
                <span className="newproject-required">*</span>
              </label>
              <DatePicker
                className="newproject-datepicker"
                format="DD-MM-YYYY"
                value={projectDetails.endDateForDOJ}
                onChange={(date) =>
                  handleProjectDetailChange("endDateForDOJ", date)
                }
                minDate={datePickerMinDate}
                maxDate={datePickerMaxDate}
                disabledDate={disabledDateOutsideRange}
                // disabled={true}
              />

            </div>
          </div>
        </div>

        {/* Component 3: Department Covered in Study */}
        <div
          className={`newproject-section ${
            isProjectCreated ? "" : "newproject-section-disabled"
          }`}
        >
          <div className="newproject-header-row">
            <h3 className="newproject-section-title">
              Department Covered in Study
              <span className="newproject-required">*</span>
            </h3>
            <button
              className="newproject-add-btn"
              onClick={handleAddDepartment}
              disabled={!isProjectCreated}
            >
              {/* <span className="newproject-plus-icon">+</span> */}
              Add New Dept.
            </button>
          </div>

          <div className="newproject-department-container">
            {departments.map((dept, index) => (
              <div className="newproject-department-item" key={`dept-${index}`}>
                <input
                  type="text"
                  className="newproject-department-input"
                  placeholder="Enter Department Name"
                  value={dept}
                  onChange={(e) => updateDepartment(index, e.target.value)}
                  disabled={!isProjectCreated}
                />
                <button
                  type="button"
                  className="newproject-delete-btn"
                  onClick={() => handleDeleteDepartment(index)}
                  disabled={!isProjectCreated}
                  aria-label="Delete department"
                  title="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
          <ErrorMessage message={errors.departments} />
        </div>

        {/* Component 4: Designation Covered in Study */}
        <div
          className={`newproject-section ${
            isProjectCreated ? "" : "newproject-section-disabled"
          }`}
        >
          <div className="newproject-header-row">
            <h3 className="newproject-section-title">
              Designation Covered in Study
              <span className="newproject-required">*</span>
            </h3>
            <button
              className="newproject-add-btn"
              onClick={handleAddDesignation}
              disabled={!isProjectCreated}
            >
              {/* <span className="newproject-plus-icon">+</span> */}
              Add New Designation
            </button>
          </div>

          <div className="newproject-designation-container">
            {designations.map((designation, index) => (
              <div
                className="newproject-designation-item"
                key={`desig-${index}`}
              >
                <input
                  type="text"
                  className="newproject-designation-input"
                  placeholder="Enter Designation Name"
                  value={designation}
                  onChange={(e) => updateDesignation(index, e.target.value)}
                  disabled={!isProjectCreated}
                />
                <button
                  type="button"
                  className="newproject-delete-btn"
                  onClick={() => handleDeleteDesignation(index)}
                  disabled={!isProjectCreated}
                  aria-label="Delete designation"
                  title="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
          <ErrorMessage message={errors.designations} />
        </div>

        <div className="newproject-next-btn-container">
          <button
            // className="newproject-next-btn"
            className={`newproject-next-btn ${
              isProjectCreated
                ? "newproject-next-btn-active"
                : "newproject-next-btn-disabled"
            }`}
            onClick={handlesubmit}
            disabled={!isProjectCreated}
          >
            NEXT
          </button>
        </div>
      </div>
    </>
  );
};

export default NewProject;
